import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-archive-content',
  templateUrl: './help-archive-content.component.html'
})
export class HelpArchiveContentComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router) {
  }
  archive_header;
  archive_body;
  archive_para1header;
  archive_para1body;
  binary_image;
  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
   this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.gethelparchivecontentlabels();
  }
  imageURL
  gethelparchivecontentlabels() {

    this.graphQlService.gethelparchivecontentLabels().subscribe(data => {
      if (data != "") {
        var labels = data.result.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.archive_header = labels.filter(x => x.key == "archive_header").map(y => y.value);
        this.archive_body = labels.filter(x => x.key == "archive_body").map(y => y.value);
        this.archive_para1header = labels.filter(x => x.key == "archive_para1header").map(y => y.value);
        this.archive_para1body = labels.filter(x => x.key == "archive_para1body").map(y => y.value);
        this.binary_image = labels.filter(x => x.key == "binary_image").map(y => y.value);
        this.imageURL = data.imgURL;
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }

}
